import ReactDOM from 'react-dom/client';
import './assets/css/index.css';
import App from './App';
import { ProSidebarProvider } from 'react-pro-sidebar';
import { store } from './store/store';
import { Provider } from 'react-redux';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <Provider store = {store}>
    <ProSidebarProvider>
      <App />
    </ProSidebarProvider>
    </Provider>
  </>
);

